// Thin wrapper that renders the Scribenote mascot SVG assets.
// Usage: <Mascot name="Sage" size={120} />          → round icon (default)
//        <Mascot name="Sage" size={120} head />      → head crop
//        <Mascot name="Sage" size={120} full />      → full-body pose
import glimmerIcon from "../assets/mascots/Glimmer-Icon.svg";
import ottoIcon from "../assets/mascots/Otto-Icon.svg";
import ottoFull from "../assets/mascots/Otto.svg";
import quillHead from "../assets/mascots/Quill-Head.svg";
import quillIcon from "../assets/mascots/Quill-Icon.svg";
import quillFull from "../assets/mascots/Quill.svg";
import sageHead from "../assets/mascots/Sage-Head.svg";
import sageIcon from "../assets/mascots/Sage-Icon.svg";
import sageFull from "../assets/mascots/Sage.svg";
import summiHead from "../assets/mascots/Summi-Head.svg";
import summiIcon from "../assets/mascots/Summi-Icon.svg";
import summiFull from "../assets/mascots/Summi.svg";

export type MascotName = "Quill" | "Summi" | "Sage" | "Otto" | "Glimmer";

type MascotVariants = { icon: string; head?: string; full?: string };

const FILES: Record<MascotName, MascotVariants> = {
  Quill: { icon: quillIcon, head: quillHead, full: quillFull },
  Summi: { icon: summiIcon, head: summiHead, full: summiFull },
  Sage: { icon: sageIcon, head: sageHead, full: sageFull },
  Otto: { icon: ottoIcon, full: ottoFull },
  Glimmer: { icon: glimmerIcon },
};

type MascotProps = {
  name: MascotName;
  size?: number;
  head?: boolean;
  full?: boolean;
  style?: React.CSSProperties;
};

export function Mascot({
  name,
  size = 120,
  head = false,
  full = false,
  style,
}: MascotProps) {
  const files = FILES[name];
  const src = (full && files.full) || (head && files.head) || files.icon;
  const isSquare = !full && !head;

  return (
    <img
      src={src}
      alt={`${name} the Scribenote Companion`}
      width={size}
      height={isSquare ? size : undefined}
      style={
        {
          "--mascot-size": `${size}px`,
          ...style,
        } as React.CSSProperties
      }
      className={`block w-[var(--mascot-size)] object-contain ${
        isSquare ? "h-[var(--mascot-size)]" : "h-auto"
      }`}
    />
  );
}
